import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import ApiConfig from "../api/ApiConfig";
import {
  PostCallWithAuthToken,
  postMultipartWithAuthCallWithErrorResponse,
} from "../api/ApiServices";
import { AppContext } from "../context/AppContext";

export default function ReportTabs({
  setSalesReport,
  setPurchaseReport,
  setLoading,
  setShow,
  reportPayLoad,
  setReportPayLoad
}) {
  const { currentRoute } = useContext(AppContext);

  useEffect(() => {
    if (currentRoute?.includes("salesReport")) {
      getSalesReport();
    } else if (currentRoute?.includes("purchaseReport")) {
      getPurchaseReport();
    }
  }, [reportPayLoad]);

  const getSalesReport = () => {
    setLoading(true);
    PostCallWithAuthToken(ApiConfig.GET_SALES_REPORT, JSON.stringify(reportPayLoad))
      .then((res) => {
        console.log(res);
        if (res.json.success) {
          res.json.data && setSalesReport(res.json.data);
         
        } else {
          setSalesReport([]);
        }

      })
      .catch((err) => console.log(err))
      .finally(()=>{
         setLoading(false)
      });
  };

  const getPurchaseReport = () => {

    setLoading(true);
    PostCallWithAuthToken(ApiConfig.GET_PURCHASE_REPORT, JSON.stringify(reportPayLoad))
      .then((res) => {
        console.log(res);
        setPurchaseReport(res.json.data);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };


  return (
    <div>
      <div className="sub-header-role reportSaleHEader">
        <h6 className="mt-2">
          {" "}
          {`${currentRoute?.includes("salesReport")
            ? "Sales"
            : currentRoute?.includes("invoice-settlement")
              ? "Invoice Settlement"
              : "Purchase"
            }`}{" "}
          Report{" "}
        </h6>
        {currentRoute?.includes("invoice-settlement") ? (
          <button
            style={{
              border: "none",
              padding: "10px 10px",
              backgroundColor: "transparent",
              color: "#3DA298",
              textDecoration: "underline",
            }}
            onClick={() => setShow(true)}
          >
            + Add Bank Account
          </button>
        ) : (
          <ui className="salasReport_topList">
            <li
              onClick={() => {
                setReportPayLoad({
                  ...reportPayLoad,
                  payMode: "All"
                });
              }}
              className={reportPayLoad.payMode === "All" ? "activetabs" : ""}
            >
              All
            </li>
            <li
              onClick={() => {
                setReportPayLoad({
                  ...reportPayLoad,
                  payMode: "Cash"
                });
              }}
              className={reportPayLoad.payMode === "Cash" ? "activetabs" : ""}
            >
              Cash
            </li>
            <li
              onClick={() => {
                setReportPayLoad({
                  ...reportPayLoad,
                  payMode: "Cheque"
                });
              }}
              className={reportPayLoad.payMode === "Cheque" ? "activetabs" : ""}
            >
              Cheque
            </li>
            <li
              onClick={() => {
                setReportPayLoad({
                  ...reportPayLoad,
                  payMode: "Online"
                });
              }}
              className={reportPayLoad.payMode === "Online" ? "activetabs" : ""}
            >
              Online
            </li>
            <li
              onClick={() => {
                setReportPayLoad({
                  ...reportPayLoad,
                  payMode: "Credit"
                });
              }}
              className={reportPayLoad.payMode === "Credit" ? "activetabs" : ""}
            >
              Credit
            </li>
          </ui>
        )}
      </div>

    </div>
  );
}
